query AnalyticsSalesByPromocode(
  $filter: AnalyticsSalesFilterInput!
  $limit: Int
) {
  analyticsSales(filter: $filter) {
    currency
    salesByPromocode(limit: $limit) {
      promocodeId
      title
      sales
      revenue
    }
  }
}
